export class VendorNoteModel {
    public id: number;
    public vendorId: number;
    public note: string;
    public createdByName: string;
    public createdByRole: string;
    public createdOn: string;
}
